import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import MoveableTable from './MoveableTable';
import axios from 'axios';
import api from '../../config.json'
import swal from 'sweetalert';
import { useEventCallback } from '@mui/material';

const ConfigReport = ({ history,Heading }) => {
    const [reportData, setReportData] = useState({})
    const [types, setAllTypes] = useState([])
    const location = useLocation()
    useEffect(() => {
        GetAllInspetcionTypes()
        if (location.state && location.state.action == 'update') {
            setReportData(location.state.data)
        }
    }, [location])
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
useEffect(() => {
Heading('Config Report Master')
}, [])

    const handleOnChange = (e) => {
        const obj = { ...reportData }
        const { name, value } = e.target;
        obj[name] = value
        setReportData(obj)
    }

    const handleSave = () => {
        if (location.state.action == 'update') {
            axios.patch(api.api + `ConfigReport/${reportData._id}`, reportData)
                .then((result) => {
                    swal('Data Saved Successfully');
                    history.push('/setting/configreport/list')
                })
                .catch((err) => {
                    swal(`${err}`);
                })
        } else {
            axios.post(api.api + "ConfigReport", reportData)
                .then((result) => {
                    swal('Data Saved Successfully');
                    history.push('/setting/configreport/list')
                })
                .catch((err) => {
                    swal(`${err}`);
                })
        }

    }

    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType }
                    reports.push(obj)
                })
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }
    return (
        <>
            <MoveableTable reportData={reportData} handleOnChange={handleOnChange} reportTypes={types} />
            <div className='text-center'>
                <button onClick={handleSave} className='btn-sm btn-primary'>Save</button>
                <button onClick={() => history.push('/setting/configreport/list')} className='btn-sm btn-primary ml-2'>Cancel</button>
            </div>
        </>
    );
}

export default ConfigReport;